import { Link } from "react-router-dom";
import { MapPin, Star, BadgeCheck, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { inr } from "@/lib/api";

const AVAIL = {
  available: { label: "Available", cls: "bg-sage/60 text-ink" },
  unavailable: { label: "Unavailable", cls: "bg-ink/10 text-ink/60" },
  enquiry_required: { label: "Enquiry Required", cls: "bg-blush/60 text-ink" },
};

export function ArtistCard({ artist }) {
  const avail = AVAIL[artist.availability_status] || AVAIL.available;
  return (
    <div
      data-testid={`artist-card-${artist.slug}`}
      className="bg-white rounded-2xl overflow-hidden border border-[#EAE5DF] hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300 ease-out flex flex-col"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-cream">
        <img src={artist.photo} alt={artist.name} loading="lazy" className="w-full h-full object-cover object-top" />
        <span data-testid={`artist-availability-${artist.slug}`} className={`absolute top-3 left-3 text-xs font-semibold px-3 py-1 rounded-full ${avail.cls}`}>
          {avail.label}
        </span>
        <span className="absolute top-3 right-3 bg-ivory/90 backdrop-blur text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
          <Star className="w-3.5 h-3.5 text-gold fill-gold" /> {artist.rating}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-serif text-2xl text-ink">{artist.name}</h3>
        {artist.title && <p className="text-xs uppercase tracking-widest text-velvet font-semibold mt-1">{artist.title}</p>}
        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-sm text-ink/60">
          <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {artist.location}</span>
          <span className="flex items-center gap-1"><BadgeCheck className="w-3.5 h-3.5" /> {artist.experience_years}+ yrs</span>
          <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> From {inr(artist.starting_price)}</span>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {(artist.services || []).slice(0, 3).map((s) => (
            <span key={s} className="text-[11px] bg-cream text-ink/70 px-2.5 py-1 rounded-full">{s}</span>
          ))}
          {(artist.services || []).length > 3 && (
            <span className="text-[11px] bg-cream text-ink/70 px-2.5 py-1 rounded-full">+{artist.services.length - 3} more</span>
          )}
        </div>
        <div className="mt-5 pt-4 border-t border-[#EAE5DF] flex gap-2 mt-auto">
          <Link to={`/makeup-artists/${artist.slug}`} className="flex-1">
            <Button data-testid={`view-profile-${artist.slug}`} variant="outline" className="w-full rounded-full border-ink/20 text-ink hover:bg-cream">
              View Profile
            </Button>
          </Link>
          <Link to={`/enquire?artist=${artist.slug}`} className="flex-1">
            <Button data-testid={`enquire-artist-${artist.slug}`} className="w-full rounded-full bg-velvet hover:bg-velvethover text-ink font-semibold active:scale-95 transition-transform">
              Enquire Now
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
